import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useIdleCallback from '@glass/web/modules/loading/useIdleCallback';
import useIsDocumentReadyPriorityLoadedIdle from '@glass/web/modules/loading/useIsDocumentReadyPriorityLoadedIdle';

import { loadAuthDialog } from '@glass/shared/components/Auth/LazyAuthDialog';
import useExitIntent, {
  LINK_BLOCK_EXIT_REASON,
} from '@glass/shared/components/hooks/useExitIntent';
import { selectSaveProgressEnabled } from '@glass/shared/modules/authForm';
import promptSaveProgressAction, {
  loadSaveProgressBaseDialog,
} from '@glass/shared/modules/resumes/actions/promptSaveProgressAction';

const preloadCallback = () => Promise.all([loadAuthDialog(), loadSaveProgressBaseDialog()]);

const useSaveResumeProgress = ({ skip, resumeId, preload }) => {
  const saveProgressEnabled = useSelector(selectSaveProgressEnabled);

  const isDocumentReadyPriorityLoadedIdle = useIsDocumentReadyPriorityLoadedIdle();
  useIdleCallback(preloadCallback, { enabled: preload && isDocumentReadyPriorityLoadedIdle });

  const dispatch = useDispatch();
  const handleExitIntent = useCallback(
    (reason) => {
      return dispatch(
        promptSaveProgressAction({
          resumeId,
          title: `Wait, ${reason === LINK_BLOCK_EXIT_REASON ? 'one sec' : "don't leave"}!`,
          reason,
        }),
      );
    },
    [resumeId, dispatch],
  );

  useExitIntent({
    onExit: handleExitIntent,
    skip: skip || !saveProgressEnabled,
  });
};

export default useSaveResumeProgress;
